import React from 'react';
import { useNavigate } from 'react-router-dom';
import TokenService from '../../Services/Token.service';
import Logo from '../../Assets/images/donorx-logo-trademark.png';

export default function SessionTimeout() {
  const navigate = useNavigate();

  const handleRelogin = () => {
    TokenService.removeUser();
    localStorage.removeItem('app_session_timed_out');
    navigate('/login');
  };

  return (
    <div className="el-login-sec el-session-time-out d-flex align-items-center justify-content-center bg-light min-vh-100">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-5 col-lg-6 col-md-8">
            <div className="card shadow-lg border-0 p-4 el-session-card">

              {/* Logo */}
              <div className="text-center mb-4 radio-pointer">
                <img
                  src={Logo}
                  className="img-fluid mb-3"
                  alt="DonorX"
                  onClick={handleRelogin}
                  style={{ maxWidth: '280px' }}
                />
              </div>

              {/* Content */}
              <div className="text-center">
                <h1 className="el-title el-404-title mb-3">
                  Session Timed Out
                </h1>

                <p className="text-muted mb-4">
                  Your session has expired due to inactivity.
                  Please re-login to continue where you left off.
                </p>

                <button
                  className="el-btn-primary px-4 py-2"
                  onClick={handleRelogin}
                >
                  Re-Login
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
